import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {AttributeSetLambdaParameters} from "#template/nodes/geometry-graph/attribute-set/attribute-set-lambda/geometry-attribute-set-lambda-node"
import {
    GeometryAttributeSetLambdaNode,
    attributeSetLambdaParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/attribute-set-lambda/geometry-attribute-set-lambda-node"

export type MeshGeometryAttributeSetLambdaParameters = AttributeSetLambdaParameters<2>

const definition: TemplateNodeDefinition<MeshGeometryAttributeSetLambdaParameters> = {
    nodeClass: "MeshGeometryAttributeSetLambda",
    validation: {
        parameters: attributeSetLambdaParametersSchema<2>(),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryAttributeSetLambda
    extends GeometryAttributeSetLambdaNode<2, MeshGeometryAttributeSetLambdaParameters>
    implements MeshGeometryAttributeSetLikeNode
{
    get [meshGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
